/**
 * Generate a unique draggable ID for a grid row entity.
 *
 * @param {Object} entity - The row entity object
 * @param {number} startIndex - The start index for this grid
 * @param {number} index - The index of this entity within the grid data array
 * @returns {string} - Unique draggable ID in format "grid-item-{id}"
 */
export const getDraggableKey = (entity, startIndex, index) => {
  const id = entity.id || entity.guid || `idx-${startIndex + index}`
  return `grid-item-${id}`
}

/**
 * Generate a unique droppable ID for a grid or subgrid.
 *
 * @param {number} level - The nesting level (0 for root grid, 1+ for subgrids)
 * @param {string|number} parentId - The parent entity ID (for subgrids)
 * @returns {string} - Unique droppable ID
 */
export const getDroppableKey = (level = 0, parentId = null) => {
  return parentId
    ? `grid-droppable-${level}-${parentId}`
    : `grid-droppable-${level}`
}

/**
 * Calculate the new index from a drag result.
 * Returns null if the drag was cancelled or invalid.
 *
 * @param {Object} result - The drag result from react-beautiful-dnd
 * @returns {number|null} - The new index, or null if invalid
 */
export const calculateNewIndex = (result) => {
  const {source, destination} = result

  // No destination (dropped outside)
  if (!destination) return null

  // Can only reorder within the same droppable
  if (source.droppableId !== destination.droppableId) return null

  // No actual movement
  if (source.index === destination.index) return null

  return destination.index
}
